// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultuser: 'chemrobouser',
  defaultkey: 'SCiq#6K02F#f',

  // appUrl: 'http://localhost:5001',

  // Old node
  // appUrl: 'https://apibeta.chemrobotics.com',

  // New node
  appUrl: 'https://adminbackend.chemrobotics.com',

  // appUrl: 'https://i2radminbackend.chemrobotics.com',
};

// this.toastr.warning("Please fill any one combination field to search!");

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
